<template>
  <div class="brief flex">
    <div class="brief-cover">
      <img :src="data.courseLogo" v-if="data.courseLogo" />
      <img :src="$oss('common/empty-img.png')" v-else />
    </div>
    <div class="flex-1 flex flex-column flex-between">
      <div>
        <div class="brief-name">{{ data.courseName }}</div>
        <div class="brief-brief">{{ data.courseBrief }}</div>
      </div>
      <div class="brief-view">
        <el-button type="primary" plain @click="toView">立即观看</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    toPay() {
      if (this.token) {
        this.$router.push({
          name: "trainOrderConfirm",
          query: { id: this.data.courseId },
        });
      } else {
        this.$store.dispatch("login");
      }
    },
    toView() {
      // 先判断文件类型
      const { courseUrl, courseId } = this.data;
      const type = this.fileType(courseUrl);
      if (type == "video") {
        this.$router.push({
          name: "onlineVideoView",
          query: { id: courseId },
        });
      } else {
        window.open(courseUrl);
      }
    },
    fileType(filePath) {
      const index = filePath.lastIndexOf(".");
      const ext = filePath.substr(index + 1);
      const vType = ["mp4", "avi", "mov", "rmvb", "rm", "flv", "3gp"];
      if (vType.indexOf(ext.toLowerCase()) != -1) {
        return "video";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.brief {
  background: white;
  padding: 15px;
  margin-bottom: 20px;
  &-cover {
    width: 557px;
    height: 310px;
    margin-right: 15px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-name {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 25px;
  }
  &-brief {
    font-size: 12px;
    color: #666666;
    margin-bottom: 22px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
